import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-conversations }}",{ moduleName: "embercom/components/modal/company-delete.hbs" })